import React from "react";
import InputTextControl from "./InputTextControl";
import InputHiddenControl from "./InputHiddenControl";
import InputTextarea from "./InputTextarea";
import InputDateControl from "./InputDateControl";
import InputEmailControl from "./InputEmailControl";
import InputColorPicker from "./InputColorPicker";
import InputNumberControl from "./InputNumberControl";
import InputSelect from "./InputSelect";
import InputRadio from "./InputRadio";
import InputCheckbox from "./InputCheckbox";
import InputSwitch from "./InputSwitch";
import InputButtonGroup from "./InputButtonGroup";

const Input = (props) => {
    if (props.type === "text") return <InputTextControl {...props} />;
    if (props.type === "hidden") return <InputHiddenControl {...props} />;
    if (props.type === "textarea") return <InputTextarea {...props} />;
    if (props.type === "number") return <InputNumberControl {...props} />;
    if (props.type === "date" || props.type === "datetime") return <InputDateControl {...props} />;
    if (props.type === "email") return <InputEmailControl {...props} />;
    if (props.type === "colorpicker") return <InputColorPicker {...props} />;
    if (props.type === "select") return <InputSelect {...props} />;
    if (props.type === "radio") return <InputRadio {...props} />;
    if (props.type === "checkbox") return <InputCheckbox {...props} />;
    if (props.type === "switch") return <InputSwitch {...props} />;
    if (props.type === "buttongroup") return <InputButtonGroup {...props} />;

    return <InputTextControl {...props} />;
};

export default Input;
